export default __webpack_public_path__ + "static/media/menu9.8710c164.png";